import { WINNER_LIST_DEFAULT_COLOR } from './constants';

type PlayerIconProps = {
  width?: number;
  height?: number;
  fillColor?: string;
}

export const PlayerIcon = ({
  width = 12,
  height = 14,
  fillColor = WINNER_LIST_DEFAULT_COLOR,
  ...props
}: PlayerIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="3 3 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <circle
          cx={9.28927}
          cy={3.363}
          r={3.00509}
          fill={fillColor}
        />
      </g>
      <g>
        <path
          // eslint-disable-next-line max-len
          d="M4.33206 11.4642C4.12276 11.342 3.99681 11.1144 4.01206 10.8725C4.13445 8.93093 5.19138 7.44604 7.32085 7.44604H11.257C13.3864 7.44604 14.4434 8.93092 14.5658 10.8725C14.581 11.1144 14.4551 11.342 14.2458 11.4642C12.785 12.3176 11.0928 12.8054 9.2889 12.8054C7.48504 12.8054 5.79283 12.3176 4.33206 11.4642Z"
          fill={fillColor}
        />
      </g>
    </g>
  </svg>
);
